import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { EditorWorkerClient } from './editorWorkerServiceImpl.js';
import * as types from '../../../base/common/types.js';
/**
 * Create a new web worker that has model syncing capabilities built in.
 * Specify an AMD module to load that will `create` an object that will be proxied.
 */

export function createWebWorker(modelService, opts) {
  return new MonacoWebWorkerImpl(modelService, opts);
}

var MonacoWebWorkerImpl = /*#__PURE__*/function (_EditorWorkerClient) {
  _inherits(MonacoWebWorkerImpl, _EditorWorkerClient);

  var _super = _createSuper(MonacoWebWorkerImpl);

  function MonacoWebWorkerImpl(modelService, opts) {
    var _this;

    _classCallCheck(this, MonacoWebWorkerImpl);

    _this = _super.call(this, modelService, opts.keepIdleModels || false, opts.label);
    _this._foreignModuleId = opts.moduleId;
    _this._foreignModuleCreateData = opts.createData || null;
    _this._foreignModuleHost = opts.host || null;
    _this._foreignProxy = null;
    return _this;
  } // foreign host request


  _createClass(MonacoWebWorkerImpl, [{
    key: "fhr",
    value: function fhr(method, args) {
      if (!this._foreignModuleHost || typeof this._foreignModuleHost[method] !== 'function') {
        return Promise.reject(new Error('Missing method ' + method + ' or missing main thread foreign host.'));
      }

      try {
        return Promise.resolve(this._foreignModuleHost[method].apply(this._foreignModuleHost, args));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }, {
    key: "_getForeignProxy",
    value: function _getForeignProxy() {
      var _this2 = this;

      if (!this._foreignProxy) {
        this._foreignProxy = this._getProxy().then(function (proxy) {
          var foreignHostMethods = _this2._foreignModuleHost ? types.getAllMethodNames(_this2._foreignModuleHost) : [];
          return proxy.loadForeignModule(_this2._foreignModuleId, _this2._foreignModuleCreateData, foreignHostMethods).then(function (foreignMethods) {
            _this2._foreignModuleCreateData = null;

            var proxyMethodRequest = function proxyMethodRequest(method, args) {
              return proxy.fmr(method, args);
            };

            var createProxyMethod = function createProxyMethod(method, proxyMethodRequest) {
              return function () {
                var args = Array.prototype.slice.call(arguments, 0);
                return proxyMethodRequest(method, args);
              };
            };

            var foreignProxy = {};

            var _iterator = _createForOfIteratorHelper(foreignMethods),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var foreignMethod = _step.value;
                foreignProxy[foreignMethod] = createProxyMethod(foreignMethod, proxyMethodRequest);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            return foreignProxy;
          });
        });
      }

      return this._foreignProxy;
    }
  }, {
    key: "getProxy",
    value: function getProxy() {
      return this._getForeignProxy();
    }
  }, {
    key: "withSyncedResources",
    value: function withSyncedResources(resources) {
      var _this3 = this;

      return this._withSyncedResources(resources).then(function (_) {
        return _this3.getProxy();
      });
    }
  }]);

  return MonacoWebWorkerImpl;
}(EditorWorkerClient);